document.addEventListener('DOMContentLoaded', function () {

  // ── Nav scroll effect ─────────────────────────────────────
  var nav = document.getElementById('main-nav');
  window.addEventListener('scroll', function () {
    if (nav) nav.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });

  // ── Mobile menu ───────────────────────────────────────────
  var toggle = document.getElementById('navToggle');
  var mMenu  = document.getElementById('mobile-menu');
  if (toggle && mMenu) {
    toggle.addEventListener('click', function () {
      var open = mMenu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open);
    });
    mMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mMenu.classList.remove('open'); });
    });
  }

  // ── Scroll reveal ─────────────────────────────────────────
  var revealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry, i) {
      if (entry.isIntersecting) {
        setTimeout(function () { entry.target.classList.add('visible'); }, i * 80);
        revealObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach(function (el) { revealObs.observe(el); });

  // ── Product showcase thumbnails ───────────────────────────
  document.querySelectorAll('.sc-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.sc-thumb').forEach(function (t) { t.classList.remove('sc-thumb-active'); });
      this.classList.add('sc-thumb-active');
      var mainImg = document.getElementById('showcaseMainSrc');
      if (mainImg && this.dataset.src) {
        mainImg.style.opacity = '0';
        var src = this.dataset.src;
        setTimeout(function () { mainImg.src = src; mainImg.style.opacity = '1'; }, 150);
      }
    });
  });
  var showcaseMain = document.getElementById('showcaseMainSrc');
  if (showcaseMain) showcaseMain.style.transition = 'opacity 0.15s ease';

  // ── Video play overlay ────────────────────────────────────
  var vsPlayOverlay = document.getElementById('vsPlayOverlay');
  var vsPlayBtn     = document.getElementById('vsPlayBtn');
  if (vsPlayBtn) {
    vsPlayBtn.addEventListener('click', function () {
      var video = vsPlayBtn.closest('.vs-video-wrap').querySelector('.vs-video');
      if (video) {
        video.play();
        if (vsPlayOverlay) vsPlayOverlay.classList.add('hidden');
      }
    });
  }

  // ── FAQ accordion ─────────────────────────────────────────
  document.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var answer   = this.nextElementSibling;
      var expanded = this.getAttribute('aria-expanded') === 'true';
      // Close all
      document.querySelectorAll('.faq-q').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        if (b.nextElementSibling) b.nextElementSibling.style.display = 'none';
      });
      // Open this one if it was closed
      if (!expanded) {
        this.setAttribute('aria-expanded', 'true');
        if (answer) answer.style.display = 'block';
      }
    });
  });

  // ── AJAX Add to Cart (progressive enhancement) ───────────
  document.querySelectorAll('.atc-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn      = form.querySelector('[type="submit"]');
      var origText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (item) {
          if (btn) btn.textContent = '✓ Added!';
          showToast((item && item.title) ? item.title : 'Item');
          refreshCartCount();
          setTimeout(function () {
            if (btn) { btn.disabled = false; btn.textContent = origText; }
          }, 2400);
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = origText; }
          form.submit(); // native fallback
        });
    });
  });

  // ── Cart toast ────────────────────────────────────────────
  function showToast(title) {
    var toast = document.getElementById('cartToast');
    var msg   = document.getElementById('toastMsg');
    if (!toast) return;
    if (msg) msg.textContent = title + ' added to cart!';
    toast.classList.add('visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('visible'); }, 4500);
  }

  // ── Cart count refresh ────────────────────────────────────
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.getElementById('cartCount');
        if (el) { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? 'flex' : 'none'; }
      }).catch(function () {});
  }

  // ── Product page thumbnails ───────────────────────────────
  document.querySelectorAll('.pfp-thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('.pfp-thumb').forEach(function (x) { x.classList.remove('pfp-thumb-active'); });
      this.classList.add('pfp-thumb-active');
      var img = document.getElementById('pfpMainImg');
      if (img && this.dataset.src) {
        img.style.opacity = '0';
        var src = this.dataset.src;
        setTimeout(function () { img.src = src; img.style.opacity = '1'; }, 150);
      }
    });
  });

});
